import type { Invoice, ITransaction } from '../types';
import type { IDataPlan } from '../types/dataPlan.type';
import type { InsuranceVehicle, InsurancePlan } from '../types/insurance.type';
import type { Topup } from '../types/topup.type';
import { Api } from './api';

export class TransactionApi extends Api {

  static async getTopup(productId: number, number: string) {
    return this.get<Topup>('/transactions/topup', {
      params: { productId, number },
      timeout: 30000
    });
  }

  static async sendServiceTopup(productId: number, number: string, amount: number) {
    return this.post<ITransaction>('/transactions/send-service-topup', {
      productId,
      number,
      amount
    });
  }
  
  static async getDataPlans(productId: number, phone: string) {
    return this.get<IDataPlan[]>(`/transactions/data-plans/${productId}/${phone}`, { timeout: 30000 });
  }

  static async sendDataPlan(productId: number, phone: string, planId: string) {
    return this.post<ITransaction>('/transactions/send-data-plan', { productId, phone, planId });
  }

  static async sendPin(productId: number, price: number) {
    return this.post<ITransaction>('/transactions/send-pin', { productId, price });
  }

  static async getInvoice(productId: number, nic: string) {
    return this.get<Invoice>(`/transactions/invoice/${productId}/${nic}`, { timeout: 30000 });
  }

  static async payInvoice(productId: number, nic: string, amount: number) {
    return this.post<ITransaction>('/transactions/pay-invoice', {
      productId,
      nic,
      amount
    });
  }

  static async cancelInvoice(id: number) {
    return this.post(`/transactions/cancel-invoice/${id}`);
  }

  static async getInsuranceVehicles(productId: number) {
    return this.get<InsuranceVehicle[]>(`/products/${productId}/insurances/vehicles`, { timeout: 30000 });
  }

  static async getInsurancePlans(productId: number, vehicleType: string) {
    return this.get<InsurancePlan[]>(`/products/${productId}/insurances/vehicles/${vehicleType}/plans`, { timeout: 30000 });
  }

  static async buyInsurance(productId: number, 
    insurance: {
      vehicleType: string;
      chassis: string;
      vigency: string; 
      docNumber: string;
      phone: string;
    }
  ) {
    return this.post<ITransaction>(`/products/${productId}/insurances/buy`, insurance);
  }

  static async cancelInsurance(productId: number, transactionId: number) {
    return this.post(`/products/${productId}/insurances/${transactionId}/cancel`);
  }
}
